import FrontPageTabs from "components/front-page/FrontPageTabs";
import HeroButtons from "components/front-page/HeroButtons";
import WhyChooseUs from "components/front-page/WhyChooseUs";

export default function FrontPage() {
  return (
    <div className="text-[var(--dash-text)]">
      <div className="mx-auto max-w-6xl px-2 pb-12 pt-2 md:px-8 md:pb-16 md:pt-8 lg:pt-16">
        <header className="mb-16 text-center md:mb-24">
          <h1 className="text-4xl font-extrabold leading-[1.1] tracking-[-0.04em] text-[var(--dash-text-strong)] sm:text-5xl md:text-6xl lg:text-7xl">
            Grow on Telegram with Telegram Hub
          </h1>

          <div className="mb-12 mt-12 md:mb-16 md:mt-20">
            <WhyChooseUs />
          </div>
          <div className="mb-12">
            <HeroButtons />
          </div>
        </header>

        <div id="tabs-section" className="scroll-mt-8 flex min-h-dvh flex-col">
          <div className="flex flex-1 flex-col justify-center py-10 md:py-14">
            <section className="mb-10 shrink-0 text-center md:mb-12">
              <span className="inline-block rounded-full border border-[#229ED9] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-[#229ED9] sm:text-xs">
                Quick Actions
              </span>
              <h2 className="mt-5 text-2xl font-bold tracking-tight text-[var(--dash-text-strong)] sm:text-3xl md:mt-6 md:text-4xl">
                What would you like to do today?
              </h2>
              <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-[var(--dash-text-muted)] md:mt-4 md:text-lg">
                Manage your plan, explore extensions, or get support — everything is right here.
              </p>
            </section>
            <FrontPageTabs />
          </div>
        </div>
      </div>
    </div>
  );
}
